import React, { useContext, useEffect, useState } from "react";
import OwlCarousel from "react-owl-carousel3";

import { Link, useNavigate } from "react-router-dom";
import { LoaderContext } from "../../AuthContext/AuthContext";
import { t } from "i18next";
import { GetPujaLookupList } from "../../ApiServices/Puja/PujaApi";
import { GetBannerWebSiteList } from "../../ApiServices/Banner/BannerApi";
import { pujaServiceID, pujaSubServiceID } from "../enum";

const MainSlider = () => {
  const navigate = useNavigate()
  const { setLoader, selectedLanguageID, formatToIndianCurrency, isLanguageUpdate } = useContext(LoaderContext);
  const [bannerDetails, setBannerDetails] = useState([])

  const options = {
    loop: true,
    animateOut: "fadeOut",
    animateIn: "fadeIn",
    items: 1,
    autoplay: true,
    autoplayTimeout: 7000,
    smartSpeed: 1000,
    nav: false,
    dots: true,
    margin: 0,
  };



  useEffect(() => {
    GetBannerWebSiteListData()
  }, [selectedLanguageID])


  const GetBannerWebSiteListData = async () => {
    // setLoader(true);
    try {
      const response = await GetBannerWebSiteList(selectedLanguageID);

      if (response?.statusCode === 200) {
        const list = response?.responseData?.data;
        setLoader(false);
        setBannerDetails(list);

      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  const handleNavigate = (banner) => {
    if (banner.moduleSlug == null || banner.moduleSlug === "") {
      switch (banner.pujaServiceID) {
        case pujaServiceID.Puja:
          if (banner.pujaSubServiceID === pujaSubServiceID.RemedyPuja)
            navigate(`/remedy-puja`);
          else if (banner.pujaSubServiceID === pujaSubServiceID.HomamPuja)
            navigate(`/homam-puja`);
          else if (banner.pujaSubServiceID === pujaSubServiceID.SubscriptionRemedyPuja)
            navigate(`/remedy-subscription-puja`);
          else if (banner.pujaSubServiceID === pujaSubServiceID.SubscriptionHomamPuja)
            navigate(`/homam-subscription-puja`);
          break;

        case pujaServiceID.PanditPuja:
          if (banner.pujaSubServiceID === pujaSubServiceID.PanditPuja)
            navigate(`/pandit-puja`);
          else if (banner.pujaSubServiceID === pujaSubServiceID.DailyPanditPuja)
            navigate(`/daily-pandit-puja`);
          break;

        case pujaServiceID.Temple:
          if (banner.pujaSubServiceID === pujaSubServiceID.PujaAtTemple)
            navigate(`/temple`, {
              state: { serviceName: 'PujaAtTemple' },
            });
          else if (banner.pujaSubServiceID === pujaSubServiceID.Prasad)
            navigate(`/temple`);
          else if (banner.pujaSubServiceID === pujaSubServiceID.DarshanBooking)
            navigate(`/temple`);
          else if (banner.pujaSubServiceID === pujaSubServiceID.LiveDarshan)
            navigate(`/temple`);
          break;

        case pujaServiceID.Ecommerce:
          if (banner.pujaSubServiceID === pujaSubServiceID.Product)
            navigate(`/my-store`);
          break;

        case pujaServiceID.Blog:
          navigate(`/spiritual-gyan`);
          break;

        default:
          navigate(`/`);
      }
    } else {
      switch (banner.pujaServiceID) {
        case pujaServiceID.Puja:
          if (banner.pujaSubServiceID === pujaSubServiceID.RemedyPuja)
            navigate(`/service/puja-details/${banner.moduleSlug}`);
          else if (banner.pujaSubServiceID === pujaSubServiceID.HomamPuja)
            navigate(`/service/puja-details/${banner.moduleSlug}`);
          else if (banner.pujaSubServiceID === pujaSubServiceID.SubscriptionRemedyPuja)
            navigate(`/service/puja-details/${banner.moduleSlug}`);
          else if (banner.pujaSubServiceID === pujaSubServiceID.SubscriptionHomamPuja)
            navigate(`/service/puja-details/${banner.moduleSlug}`);
          break;

        case pujaServiceID.PanditPuja:
          if (banner.pujaSubServiceID === pujaSubServiceID.PanditPuja)
            navigate(`/service/puja-details/${banner.moduleSlug}`);
          else if (banner.pujaSubServiceID === pujaSubServiceID.DailyPanditPuja)
            navigate(`/service/puja-details/${banner.moduleSlug}`);
          break;

        case pujaServiceID.Temple:
          if (banner.pujaSubServiceID === pujaSubServiceID.PujaAtTemple)
            navigate(`/service/puja-details/${banner.moduleSlug}`, {
              state: { serviceName: 'PujaAtTemple' },
            });
          else if (banner.pujaSubServiceID === pujaSubServiceID.Prasad)
            navigate(`/product-details/${banner.moduleSlug}`);
          else if (banner.pujaSubServiceID === pujaSubServiceID.DarshanBooking)
            navigate(`/temple/${banner.moduleSlug}`);
          else if (banner.pujaSubServiceID === pujaSubServiceID.LiveDarshan)
            navigate(`/temple`);
          break;

        case pujaServiceID.Ecommerce:
          if (banner.pujaSubServiceID === pujaSubServiceID.Product)
            navigate(`/product-details/${banner.moduleSlug}`);
          break;

        case pujaServiceID.Blog:
          navigate(`/spiritual-gyan/${banner.moduleSlug}`);
          break;

        default:
          navigate(`/`);
      }
    }

  }
  return (
    <section className="main-slider-two">
      {bannerDetails.length > 0 && (
        <OwlCarousel
          key={bannerDetails.length} // 👈 helps force re-init when data changes
          className="main-slider-two__carousel"
          {...options}
        >
          {bannerDetails.map((slide, index) => (
            <div className="item" key={index}>
              <div className="main-slider-two__item">
                <img
                  src={slide.webImage}
                  alt={slide.alt || "Banner"}
                  className="main-slider-two__bg"
                  loading={index === 0 ? "eager" : "lazy"}
                  fetchpriority={index === 0 ? "high" : undefined}
                  // width="1920"
                  // height="800"
                  style={{ objectFit: "fill" }}
                />

                <div className="main-slider-two__overlay"></div>
                <div className="container">
                  <div className="main-slider-two__content">
                    <h1 className="main-slider-two__title">
                      <span
                        className={
                          slide.marathi
                            ? "marathiBannerHeading"
                            : "main-slider-two__title__text"
                        }
                      >
                        <div
                          className="banner-header1"
                          dangerouslySetInnerHTML={{
                            __html: slide.header1,
                          }}
                        />

                      </span>
                    </h1>
                    <div className="main-slider-two__text">
                      <div
                        className="banner-header2"
                        dangerouslySetInnerHTML={{
                          __html: slide.header2,
                        }}
                      />
                    </div>

                    {slide.ctaName && (
                      <div
                        className="main-slider-two__btn"
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          marginTop: "15px",
                        }}
                      >
                        <button
                          onClick={() => handleNavigate(slide)}
                          className="careox-btn"
                          style={{
                            display: "inline-block",
                            width: "auto",
                            padding: "8px 16px",
                            margin: 0,
                          }}
                        >
                          <span>{slide.ctaName}</span>
                        </button>
                      </div>
                    )}


                  </div>
                </div>
              </div>
            </div>
          ))}
        </OwlCarousel>
      )}
    </section>


  );
};

export default MainSlider;


// import React, { useContext, useEffect, useState } from "react";
// import OwlCarousel from "react-owl-carousel3";

// import { Link, useNavigate } from "react-router-dom";
// import { LoaderContext } from "../../AuthContext/AuthContext";
// import { t } from "i18next";
// import { GetPujaLookupList } from "../../ApiServices/Puja/PujaApi";
// import { GetBannerWebSiteList } from "../../ApiServices/Banner/BannerApi";
// import { pujaServiceID, pujaSubServiceID } from "../enum";

// const MainSlider = () => {
//   const navigate = useNavigate()
//   const { setLoader, selectedLanguageID, formatToIndianCurrency, isLanguageUpdate } = useContext(LoaderContext);
//   const [bannerDetails, setBannerDetails] = useState([])

//   const options = {
//     loop: false,
//     animateOut: "fadeOut",
//     animateIn: "fadeIn",
//     items: 1,
//     autoplay: true,
//     autoplayTimeout: 7000,
//     smartSpeed: 1000,
//     nav: false,
//     dots: true,
//     margin: 0,
//   };



//   useEffect(() => {
//     GetBannerWebSiteListData()
//   }, [selectedLanguageID])


//   const GetBannerWebSiteListData = async () => {
//     // setLoader(true);
//     try {
//       const response = await GetBannerWebSiteList(selectedLanguageID);

//       if (response?.statusCode === 200) {
//         const list = response?.responseData?.data;
//         setLoader(false);
//         setBannerDetails(list);

//       }
//     } catch (error) {
//       setLoader(false);
//       console.log(error);
//     }
//   };

//   const handleNavigate = (banner) => {
//     if (banner.moduleSlug == null || banner.moduleSlug === "") {
//       switch (banner.pujaServiceID) {
//         case pujaServiceID.Puja:
//           if (banner.pujaSubServiceID === pujaSubServiceID.RemedyPuja)
//             navigate(`/remedy-puja`);
//           else if (banner.pujaSubServiceID === pujaSubServiceID.HomamPuja)
//             navigate(`/homam-puja`);
//           else if (banner.pujaSubServiceID === pujaSubServiceID.SubscriptionRemedyPuja)
//             navigate(`/remedy-subscription-puja`);
//           else if (banner.pujaSubServiceID === pujaSubServiceID.SubscriptionHomamPuja)
//             navigate(`/homam-subscription-puja`);
//           break;

//         case pujaServiceID.PanditPuja:
//           if (banner.pujaSubServiceID === pujaSubServiceID.PanditPuja)
//             navigate(`/pandit-puja`);
//           else if (banner.pujaSubServiceID === pujaSubServiceID.DailyPanditPuja)
//             navigate(`/daily-pandit-puja`);
//           break;

//         case pujaServiceID.Temple:
//           if (banner.pujaSubServiceID === pujaSubServiceID.PujaAtTemple)
//             navigate(`/temple`, {
//               state: { serviceName: 'PujaAtTemple' },
//             });
//           else if (banner.pujaSubServiceID === pujaSubServiceID.Prasad)
//             navigate(`/temple`);
//           else if (banner.pujaSubServiceID === pujaSubServiceID.DarshanBooking)
//             navigate(`/temple`);
//           else if (banner.pujaSubServiceID === pujaSubServiceID.LiveDarshan)
//             navigate(`/temple`);
//           break;

//         case pujaServiceID.Ecommerce:
//           if (banner.pujaSubServiceID === pujaSubServiceID.Product)
//             navigate(`/my-store`);
//           break;

//         case pujaServiceID.Blog:
//           navigate(`/spiritual-gyan`);
//           break;

//         default:
//           navigate(`/`);
//       }
//     } else {
//       switch (banner.pujaServiceID) {
//         case pujaServiceID.Puja:
//           if (banner.pujaSubServiceID === pujaSubServiceID.RemedyPuja)
//             navigate(`/service/puja-details/${banner.moduleSlug}`);
//           else if (banner.pujaSubServiceID === pujaSubServiceID.HomamPuja)
//             navigate(`/service/puja-details/${banner.moduleSlug}`);
//           else if (banner.pujaSubServiceID === pujaSubServiceID.SubscriptionRemedyPuja)
//             navigate(`/service/puja-details/${banner.moduleSlug}`);
//           else if (banner.pujaSubServiceID === pujaSubServiceID.SubscriptionHomamPuja)
//             navigate(`/service/puja-details/${banner.moduleSlug}`);
//           break;

//         case pujaServiceID.PanditPuja:
//           if (banner.pujaSubServiceID === pujaSubServiceID.PanditPuja)
//             navigate(`/service/puja-details/${banner.moduleSlug}`);
//           else if (banner.pujaSubServiceID === pujaSubServiceID.DailyPanditPuja)
//             navigate(`/service/puja-details/${banner.moduleSlug}`);
//           break;

//         case pujaServiceID.Temple:
//           if (banner.pujaSubServiceID === pujaSubServiceID.PujaAtTemple)
//             navigate(`/service/puja-details/${banner.moduleSlug}`, {
//               state: { serviceName: 'PujaAtTemple' },
//             });
//           else if (banner.pujaSubServiceID === pujaSubServiceID.Prasad)
//             navigate(`/product-details/${banner.moduleSlug}`);
//           else if (banner.pujaSubServiceID === pujaSubServiceID.DarshanBooking)
//             navigate(`/temple/${banner.moduleSlug}`);
//           else if (banner.pujaSubServiceID === pujaSubServiceID.LiveDarshan)
//             navigate(`/temple`);
//           break;

//         case pujaServiceID.Ecommerce:
//           if (banner.pujaSubServiceID === pujaSubServiceID.Product)
//             navigate(`/product-details/${banner.moduleSlug}`);
//           break;

//         case pujaServiceID.Blog:
//           navigate(`/spiritual-gyan/${banner.moduleSlug}`);
//           break;

//         default:
//           navigate(`/`);
//       }
//     }

//   }
//   return (
//     <section className="main-slider-two">
//       {bannerDetails.length > 0 && (
//         <OwlCarousel
//           key={bannerDetails.length} // 👈 helps force re-init when data changes
//           className="main-slider-two__carousel"
//           {...options}
//         >
//           {bannerDetails.map((slide, index) => (
//             <div className="item" key={index}>
//               <div className="main-slider-two__item">
//                 <img
//                   src={slide.webImage}
//                   alt={slide.alt || "Banner"}
//                   className="main-slider-two__bg"
//                   loading={index === 0 ? "eager" : "lazy"}
//                   fetchpriority={index === 0 ? "high" : undefined}
//                   width="1920"
//                   height="800"
//                 />

//                 <div className="main-slider-two__overlay"></div>
//                 <div className="container">
//                   <div className="main-slider-two__content">
//                     <h1 className="main-slider-two__title">
//                       <span
//                         className={
//                           slide.marathi
//                             ? "marathiBannerHeading"
//                             : "main-slider-two__title__text"
//                         }
//                       >
//                         <div
//                           dangerouslySetInnerHTML={{
//                             __html: slide.header1,
//                           }}
//                         />

//                       </span>
//                     </h1>
//                     <div className="main-slider-two__text">
//                       <div
//                         dangerouslySetInnerHTML={{
//                           __html: slide.header2,
//                         }}
//                       />
//                     </div>

//                     {slide.ctaName && (
//                       <div
//                         className="main-slider-two__btn"
//                         style={{
//                           display: "flex",
//                           justifyContent: "flex-start",
//                           marginTop: "15px",
//                         }}
//                       >
//                         <button
//                           onClick={() => handleNavigate(slide)}
//                           className="careox-btn"
//                           style={{
//                             display: "inline-block",
//                             width: "auto",
//                             padding: "8px 16px",
//                             margin: 0,
//                           }}
//                         >
//                           <span>{slide.ctaName}</span>
//                         </button>
//                       </div>
//                     )}


//                   </div>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </OwlCarousel>
//       )}
//     </section>


//   );
// };

// export default MainSlider;
